module.exports = __webpack_public_path__ + "media/images/uvod_foto_mobil-295bbf5b.jpg";